import { useEffect, useState } from 'react';
import {
  pushSupported,
  permissionState,
  requestPermissionAndSubscribe,
} from '../utils/pushSubscribe';
import classes from './EnablePushChip.module.scss';

// Compact pill that lives in the floating top-right actions cluster whenever
// push is supported but the user hasn't decided yet. Replaces the old
// EnablePushBanner (green slide-down) which was too intrusive on every page.
export default function EnablePushChip() {
  const [permission, setPermission] = useState<NotificationPermission | 'unsupported'>(() => permissionState());
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const onVisible = () => {
      if (document.visibilityState === 'visible') setPermission(permissionState());
    };
    document.addEventListener('visibilitychange', onVisible);
    return () => document.removeEventListener('visibilitychange', onVisible);
  }, []);

  if (!pushSupported() || permission !== 'default') return null;

  const handleClick = async () => {
    if (busy) return;
    setBusy(true);
    try { await requestPermissionAndSubscribe(); } catch (err) { console.warn('[EnablePushChip]', err); }
    setPermission(permissionState());
    setBusy(false);
  };

  return (
    <button
      type="button"
      className={classes.chip}
      onClick={handleClick}
      disabled={busy}
      title="Turn on notifications so you don't miss activity on your posts"
    >
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
        <path d="M13.73 21a2 2 0 0 1-3.46 0" />
      </svg>
      <span>{busy ? 'Enabling…' : 'Enable notifications'}</span>
    </button>
  );
}
